export default __webpack_public_path__ + "/dist/images/record-icon.c7e95a4acdc82f80a030b764989b02c1.svg";